import { render, staticRenderFns } from "./noticias.vue?vue&type=template&id=3575d5ca"
import script from "./noticias.vue?vue&type=script&lang=js"
export * from "./noticias.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports